const initialState = {
    session_data: {},
};

export default (state = initialState, action) => {
    switch (action.type) {
        case 'START_SESSION':
            return {
                ...state,
                session_data: action.payload,
            };
        default:
            return state;
    }
};